export default function NewsAndSupplierSectionFr() {
  return (
    <>
      <section className="w-full bg-white py-20 px-6 md:px-16">
        <div className="max-w-7xl mx-auto">
          <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">Notre engagement</span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-stone-800 mt-3 mb-6"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Qualité, Conformité &amp; Confidentialité
          </h2>
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/2 flex flex-col gap-5 text-gray-600 text-base leading-relaxed">
              <p>
                En tant que fournisseur expérimenté, nous sélectionnons des installations et des services qui répondront aux exigences de conformité nécessaires du mandat. Les spécifications des produits sont clairement identifiées et respectées à chaque livraison. Notre infrastructure et nos services comprennent un entreposage à accès contrôlé et climatisé (température) ainsi que la plus haute qualité en logistique et en mouvement des marchandises pour assurer la traçabilité et l&apos;intégrité des produits.
              </p>
              <p>
                Notre motivation et notre ambition sont de fournir une valeur maximale à nos clients et fournisseurs. Nous y parvenons en facilitant et en gérant les exigences sous confidentialité et en les alignant avec des options d&apos;approvisionnement de qualité.
              </p>
            </div>
            <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-4 content-start">
              {[
                { icon: 'ri-shield-check-line', label: 'Conformité' },
                { icon: 'ri-lock-line', label: 'Confidentialité' },
              ].map((item) => (
                <div key={item.label} className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <div className="w-10 h-10 flex items-center justify-center text-emerald-600 mb-3">
                    <i className={`${item.icon} text-2xl`} />
                  </div>
                  <div className="font-bold text-stone-800 text-sm">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
